import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import axios from 'axios'
import React, {useEffect, useState} from 'react'
import {useHistory} from 'react-router-dom'
import {hasPermission} from '../../../../../_helper/hasPermission'
import {permissions} from '../../../../../_constants/permissions'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../../../setup'
import {setClientID} from './store'
import {toast} from 'react-toastify'
import SearchableSelect from '../../../../reusable-components/forms/SearchableSelect'
const selectAuth = (state: RootState) => state.auth

interface Client {
  value: string;
  label: string;
}

const ClientDailog = ({open, onClose}) => {
  const [clients, setClients] = useState<Client[]>([])
  const [selectedClient, setSelectedClient] = useState<Client | null>(null)
  const [deleteID, setDeleteID] = useState<string>('')
  const [loading, setLoading] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const history = useHistory()
  const dispatch = useDispatch()

  const auth = useSelector(selectAuth)
  const userPermissions = auth.user.roleId

  const fetchClients = async () => {
    try {
      setLoading(true)
      const response = await axios.get('/clients/getClientNames')
      const {data} = response?.data
      const updatedclients = data.map((client) => ({
        label: client.fullName,
        value: client._id
      }))
      setClients(updatedclients)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchClients()
  }, [deleteID])

  const handleClose = () => {
    if (!open) {
      onClose()
    }
  }

  const handleSave = () => {
    try {
      if (selectedClient) {
        dispatch(setClientID(selectedClient?.value))
        localStorage.setItem('clientID', JSON.stringify(selectedClient?.value))
        if (hasPermission(userPermissions, permissions.admin_care_update)) {
          history.push({
            pathname: `/admin/care/individual-intake/${selectedClient?.value}`,
          })
        } else if (hasPermission(userPermissions, permissions.admin_care_contact_view)) {
          history.push({
            pathname: `/admin/care/contact/list/${selectedClient?.value}`,
          })
        } else if (
          hasPermission(userPermissions, permissions.admin_care_enrollment_byIndividual_update)
        ) {
          history.push({
            pathname: `/admin/care/enrollment/by-client/${selectedClient?.value}`,
          })
        } else if (hasPermission(userPermissions, permissions.admin_care_insurance_update)) {
          history.push({
            pathname: `/admin/care/insurance/${selectedClient?.value}`,
          })
        } else if (hasPermission(userPermissions, permissions.admin_care_healthData_view)) {
          history.push({
            pathname: `/admin/care/health/health-data/${selectedClient?.value}`,
          })
        }
      }
    } catch (error) {
      console.error(error)
    }
  }
  const handleClientChange = (_, client) => {
    setSelectedClient(client)
  }
  const onClickAddButton = () => {
    history.push('/admin/care/individual-intake/new')
  }

  const handleDelete = async () => {
    try {
      if (!selectedClient?.value) return
      setIsSubmitting(true) 
      setLoading(true)
      const response = await axios.delete(`/clients/softDelete/${selectedClient?.value}`)
      if (response.status === 200) {
        setDeleteID(selectedClient?.value)
        toast.success('client deleted successfully')
        setSelectedClient(null)
      }
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
      setIsSubmitting(false)
    }
  }

  const handleViewDeletedClients = () => {
    history.push('/admin/care/individual-intake/deleted-clients') // Add your actual route here
  }

  return (
    <Dialog 
      open={open} 
      onClose={handleClose} 
      fullWidth 
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '500px',  // Set your width here
          },
        },
        '& .MuiDialog-paper': {
          overflow: 'visible'  // This makes the dialog content overflow visible
        }
      }}
    >
      <DialogTitle style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
        <span>Select Client</span>
        <div>
          {!auth.user.isEditable && (
          <Button
            variant='contained'
            color='primary'
            onClick={handleViewDeletedClients}
            style={{marginRight: '8px'}}
          >
            View Deleted Clients
          </Button>
          )}
          <Button
            variant='contained'
            color='error'
            onClick={handleDelete}
            disabled={isSubmitting || !selectedClient?.value}
          >
            Delete
          </Button>
        </div>
      </DialogTitle>
      <DialogContent sx={{ overflow: 'visible' }}>  {/* Make dropdown visible */}
        <div className='gap-3' style={{ position: 'relative', zIndex: 1 }}>  {/* Ensure dropdown appears above other elements */}
          <SearchableSelect
            label="Search for client"
            options={clients.map(client => ({
              value: client.value,
              label: client.label
            }))}
            value={selectedClient?.value || ''}
            onChange={(newValue) => {
              setSelectedClient(newValue ? {
                value: newValue.value.toString(),
                label: newValue.label
              } : null)
            }}
            fullWidth
            size="small"
            required
            disabled={isSubmitting || loading}
            endAdornment={loading ? <CircularProgress color='inherit' size={20} /> : null}
          />
        </div>
        <div className='pt-5 float-end'>
          <Button variant='contained' color='primary' onClick={() => history.push('/dashboard')}>
            Back
          </Button>
          <Button
            variant='contained'
            style={{marginLeft: '8px'}}
            color='primary'
            onClick={handleSave}
            disabled={isSubmitting || loading || !selectedClient?.value}
          >
            Search
          </Button>
          <Button
            variant='contained'
            style={{marginLeft: '8px'}}
            color='primary'
            onClick={onClickAddButton}
            disabled={isSubmitting}
          >
            Add New
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ClientDailog
